import _ from 'lodash';

const metiers = {'gl': 'ME_100000', 'copro': 'ME_200000'};

class BackendApiService {

    constructor(backendApiUrl, authState) {
        this.baseUrl = backendApiUrl;

        this.headers = {
            "Content-Type": "application/json", 
            "Accept": "application/json",
            "Authorization": `${authState.accessToken.tokenType} ${authState.accessToken.accessToken}`
        };
    }

    fetchChargeDevList = function (societe,  metier){
        let data = {
            "refCabinet": societe.refSiFinance,
            "metier": metiers[metier],
        };
    
        return this.postJson("/chargesDeveloppements", data);
    }

    fetchSocietes = function (nomRegion) {
        let data = {
            "region": nomRegion,
            "metiers": [metiers.gl, metiers.copro]
        };

        return this.postJson("/cabinetsByRegion", data);
    }

    fetchEtablissements = function (nomRegion) {
        let data = {
            "region": nomRegion,
            "metiers": [metiers.gl, metiers.copro]
        };

        return this.postJson("/agences", data);
    }

    saveAffectationsEtablissement =  function (etablissement,  metier) {
        let data = {
            "refAgence": etablissement.refSiFinance,
            "metier": metiers[metier],
            "zones": etablissement[metier]
        };
    
        return this.postJson("/affectation", data);
    }

    saveAffectationsChargeDev =  function (societe, zones,  metier) {

        let affectationZoneList = [];

        for(let i in zones){
            let zone = zones[i];

            let agence = this.findAgenceByZoneCode(societe.agences, zone.code, metier);

            if(agence){
                let affZone = {refAgence: agence.refSiFinance, metier: metiers[metier]};

                let affZoneFound = _.find(affectationZoneList, affZone);
                if(affZoneFound){
                    affZoneFound.zones.push(zone);
                } else {
                    affZone.zones = [zone];
                    affectationZoneList.push(affZone);
                }
            }
        }

        let all = affectationZoneList.map(data => this.postJson("/affectation", data));

        return Promise.allSettled(all);
    }

    findAgenceByZoneCode = function(agences, zoneCode, metier) {
        
        for(let i in agences){
            let agence = agences[i];
            let zones = agence[metier];
            for(let j in zones){
                let zone = zones[j];
                if(zone.code === zoneCode)
                    return agence;
            }
        }
        return null;
    }

    postJson =  function (uri, json) {

        return fetch(this.baseUrl + uri, {
            method: 'POST',
            headers: this.headers,
            body: JSON.stringify(json)
        });
    }
}

export default BackendApiService;